
import { defineComponent } from 'vue'

/**
 * Component that is responsible to render the integration logo and name on detailed view
 */
export default defineComponent({
  name: 'IntegrationInstalledOn',

  props: {
    installedOn: {
      type: String,
      required: true
    },
    integrationDisconnected: {
      type: Boolean,
      default: false
    }
  }
})
